import React from 'react'
import SmartAutocomplete from './SmartAutocomplete'

const SoundsAutocomplete = (props: {
  sounds: string[],
  sound: string,
  onSoundChange: (sound: string) => void,
}) => {

  const {
    sounds,
    sound,
    onSoundChange
  } = props

  return (
    <SmartAutocomplete
      keyName='d'
      label="Sound"
      value={sound}
      options={sounds}
      getOptionLabel={(option) => option}
      style={{ width: 300, margin: 16 }}
      onChange={(e, sound) => sound && onSoundChange(sound)}
    />
  )
}

export default SoundsAutocomplete
